import React from 'react';

interface Props {
  fill?: string;
  width?: string;
  height?: string;
  className?: string;
}

export default function AiMagicWandIcon({ fill = '#A729D2', width = '60', height = '60', className }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 53 53"
      fill="none"
      className={className}
    >
      <path
        d="M45.0062 15L47.3562 9.85L52.5062 7.5L47.3562 5.15L45.0062 0L42.6562 5.15L37.5062 7.5L42.6562 9.85L45.0062 15Z"
        fill={fill}
      />
      <path
        d="M16.2562 15L18.6062 9.85L23.7562 7.5L18.6062 5.15L16.2562 0L13.9062 5.15L8.75625 7.5L13.9062 9.85L16.2562 15Z"
        fill={fill}
      />
      <path
        d="M45.0062 28.75L42.6562 33.9L37.5062 36.25L42.6562 38.6L45.0062 43.75L47.3562 38.6L52.5062 36.25L47.3562 33.9L45.0062 28.75Z"
        fill={fill}
      />
      <path
        d="M39.2812 20.3L32.2062 13.225C31.7062 12.75 31.0812 12.5 30.4312 12.5C29.7812 12.5 29.1562 12.75 28.6562 13.225L0.73125 41.15C-0.24375 42.125 -0.24375 43.7 0.73125 44.675L7.80625 51.75C8.30625 52.25 8.93125 52.5 9.58125 52.5C10.2312 52.5 10.8562 52.25 11.3562 51.775L39.2812 23.85C40.2562 22.875 40.2562 21.275 39.2812 20.3ZM30.4312 18.55L33.9562 22.075L31.0312 25L27.5062 21.475L30.4312 18.55ZM9.58125 46.475L6.05625 42.95L23.9812 25L27.5062 28.525L9.58125 46.475Z"
        fill={fill}
      />
    </svg>
  );
}
